import React from 'react';
import styled from 'styled-components';

import { TextBox } from '../../../text-box/text-box';
import { FolderTreeViewItemModel, ItemStatus } from './create-folder-structure-dialog';

interface Props {
  item: FolderTreeViewItemModel;
  onNameChanged: (itemId: string, name: string) => void;
}

const FolderStructureTreeViewContent = (props: Props) => {
  const [name, setName] = React.useState(props.item.name);

  const onBlur = () => {
    if (name !== props.item.name) {
      props.onNameChanged(props.item.id, name);
    }
  };

  const editable = [
    ItemStatus.Aborted,
    ItemStatus.Canceled,
    ItemStatus.Idle,
    ItemStatus.ValidationError,
  ].includes(props.item.status);

  return (
    <Component {...props}>
      {editable ? (
        <TextBox
          errorMessage={props.item.errorMessage}
          value={name}
          onBlur={onBlur}
          onChange={(e) => setName(e.target.value)}
        />
      ) : (
        <span>{name}</span>
      )}
    </Component>
  );
};

const Component = styled.div`
  position: relative;
  font-size: 0.9em;

  input[type='text'] {
    margin: 0.1em 0;
    font-size: inherit;
    padding: 0.3em;
  }
`;

export { FolderStructureTreeViewContent as FolderStructureTreeViewItem };
